import styled, { css } from "styled-components";
import { getBreakpoint } from "../../../../themes/common";
import { theme, styledSystemTheme } from "../theme/toyotaTheme";

export const Slider = styled.div<{ hasSliderButtons?: boolean }>`
    min-height: 30px;
    margin: ${({ hasSliderButtons }) => (hasSliderButtons ? "0 50px" : 0)};
    padding-bottom: ${theme.space[3]}px;
    overflow: hidden;

    @media ${getBreakpoint("up", "lg")} {
        height: auto;
    }
`;

export const SliderViewport = styled.div`
    display: flex;
    position: relative;
    align-items: center;
    width: 100%;
    min-height: 30px;
    overflow-x: hidden;

    @media ${getBreakpoint("up", "lg")} {
        height: auto;
    }
`;

type TrackType = { width?: number; left: number; enableTransition: boolean };
export const Track = styled.div.attrs<TrackType>((props) => ({
    style: { transform: `translateX(${props.left}px)` },
}))<TrackType>`
    display: flex;
    left: 0;
    flex-direction: row;
    width: ${(props) => props.width}px;
    ${(props) =>
        props.enableTransition &&
        css`
            transition: transform 0.5s;
        `};
`;

export const ImageWrapper = styled.div<{ width?: number }>`
    display: flex;
    align-items: flex-start;
    ${({ width }) =>
        width &&
        css`
            width: ${width}px;
        `};
`;

export const Image = styled.img<{ withoutBorder?: boolean }>`
    width: 90%;
    max-width: 100%;
    height: auto;
    border: ${({ withoutBorder }) => (withoutBorder ? "none" : `1px solid ${theme.colors.primaryBlack}`)};
`;

export const SliderButton = styled.button<{ alignment: string; show?: boolean }>`
    position: absolute;
    top: 50%;
    width: 40px;
    height: 40px;
    margin: 0;
    padding: 0;
    color: ${theme.colors.primaryBlack};
    background-color: transparent;
    border: 0;
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -ms-transform: translateY(-50%) translateY(10px); /* Fix for IE11 */
    transform: translateY(calc(-50% + 10px));
    transition: opacity 0.24s;

    ${({ show }) =>
        !show &&
        css`
            pointer-events: none;
            cursor: default;
            opacity: 0.4;
        `};
    ${({ alignment }) =>
        alignment === "left"
            ? css`
                  ${alignment}: ${styledSystemTheme.isRTL ? 0 : "-10px"};
              `
            : css`
                  ${alignment}: ${styledSystemTheme.isRTL ? "-10px" : 0};
              `};
`;
export const TyreInfoBody = styled.div`
    position: relative;
`;

export const DetailList = styled.dl`
    display: flex;
    flex-wrap: wrap;

    dt,
    dd {
        width: 100%;
        padding-top: ${theme.space[1]}px;
        padding-bottom: ${theme.space[1]}px;
        font-family: ${theme.fonts.base};
        font-size: 1.6rem;
        line-height: 2.4rem;
        border-top: 1px solid ${theme.colors.grey2};

        &:last-of-type {
            border-bottom: 1px solid ${theme.colors.grey2};
        }

        @media ${getBreakpoint("up", "md")} {
            width: 50%;
        }
    }

    dt {
        color: ${theme.colors.grey4};

        &:last-of-type {
            border-bottom: none;
        }

        @media ${getBreakpoint("up", "md")} {
            &:last-of-type {
                border-bottom: 1px solid ${theme.colors.grey2};
            }
        }
    }

    dd {
        padding-top: 0;
        color: ${theme.colors.primaryBlack};
        border-top: none;

        @media ${getBreakpoint("up", "md")} {
            padding-top: ${theme.space[1]}px;
            text-align: end;
            border-top: 1px solid ${theme.colors.grey2};
        }
    }
`;

export const ImageDetailedWrapper = styled.div<{ width?: number }>`
    display: flex;
    flex-direction: column-reverse;
    align-items: flex-start;
    justify-content: flex-end;
    width: ${({ width }) => width}px;

    ${ImageWrapper} {
        align-self: center;
        justify-content: center;
        width: 100%;
        max-width: 430px;
        margin-bottom: ${theme.space[3]}px;

        @media ${getBreakpoint("up", "lg")} {
            align-self: flex-start;
            margin-bottom: 0;
            margin-left: ${theme.space[3]}px;
        }
    }

    ${DetailList} {
        @media ${getBreakpoint("up", "lg")} {
            width: 50%;
        }
    }

    @media ${getBreakpoint("up", "lg")} {
        flex-direction: row;
        justify-content: flex-start;
    }

    html[dir="rtl"] & {
        ${ImageWrapper} {
            @media ${getBreakpoint("up", "lg")} {
                margin-left: 0;
                margin-right: ${theme.space[3]}px;
            }
        }
    }
`;
